import { IconProps } from "./types";

export default function IcoCamera({
	color = "#000000",
	width = "17",
	height = "16"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 17 16"
			fill="none"
		>
			<g clipPath="url(#clip0_641_1067)">
				<path
					d="M5.51875 2.025L5.19375 3H2.85938C1.75625 3 0.859375 3.89687 0.859375 5V13C0.859375 14.1031 1.75625 15 2.85938 15H14.8594C15.9625 15 16.8594 14.1031 16.8594 13V5C16.8594 3.89687 15.9625 3 14.8594 3H12.525L12.2 2.025C11.9969 1.4125 11.425 1 10.7781 1H6.94063C6.29375 1 5.72188 1.4125 5.51875 2.025ZM8.85938 6C9.65502 6 10.4181 6.31607 10.9807 6.87868C11.5433 7.44129 11.8594 8.20435 11.8594 9C11.8594 9.79565 11.5433 10.5587 10.9807 11.1213C10.4181 11.6839 9.65502 12 8.85938 12C8.06373 12 7.30066 11.6839 6.73805 11.1213C6.17545 10.5587 5.85938 9.79565 5.85938 9C5.85938 8.20435 6.17545 7.44129 6.73805 6.87868C7.30066 6.31607 8.06373 6 8.85938 6Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_641_1067">
					<path d="M0.859375 0H16.8594V16H0.859375V0Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
